import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/";
import VueLazyload from "vue-lazyload";
import infiniteScroll from "vue-infinite-scroll";
import VueCookie from "vue-cookie";
// import { userInfo } from "./api";
import dict from "./components/Dict"; // 数据字典
import { htmlDecode, htmlPlain } from "./utils/html";

import {
  Form,
  MessageBox,
  FormItem,
  Button,
  Pagination,
  Checkbox,
  Icon,
  Card,
  Autocomplete,
  Loading,
  Message,
  Notification,
  Steps,
  Step,
  Table,
  TableColumn,
  Input,
  Dialog,
  Select,
  Option,
  Popover,
  Carousel,
  CarouselItem,
  Row,
  Col,
  Image,
  PageHeader,
  Upload,
  Avatar,
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { getStore } from "/utils/storage";
import VueContentPlaceholders from "vue-content-placeholders";
import "./element-variables.css";
Vue.use(dict);

Vue.use(VueContentPlaceholders);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Checkbox);
Vue.use(Icon);
Vue.use(Autocomplete);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Input);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Card);
Vue.use(Popover);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Image);
Vue.use(PageHeader);
Vue.use(Upload);
Vue.use(Avatar);
Vue.use(Loading.directive);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$htmlDecode = htmlDecode;
Vue.prototype.$htmlPlain = htmlPlain;
Vue.use(infiniteScroll);
Vue.use(VueCookie);
Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  // loading: '/static/images/load.gif'
  // attempt: 1
});
import axios from "axios";
import VueAxios from "vue-axios";
axios.defaults.timeout = 30000;
// axios.defaults.baseURL = "/";
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.headers.common["tenant_id"] = process.env.VUE_APP_TENANT_ID;

Vue.use(VueAxios, axios);

Vue.config.productionTip = false;
const whiteList = [
  "/home",
  "/goods",
  "/login",
  "/register",
  "/goodsDetails",
  "/thanks",
  "/search",
  "/refreshsearch",
  "/refreshgoods",
]; // 不需要登陆的页面
router.beforeEach(function (to, from, next) {
  let params = {
    params: {
      token: getStore("token"),
    },
  };
  next();
  // userInfo(params).then(res => {
  //   if (res.result.state !== 1) { // 没登录
  //     if (whiteList.indexOf(to.path) !== -1) { // 白名单
  //       next()
  //     } else {
  //       next('/login')
  //     }
  //   } else {
  //     store.commit('RECORD_USERINFO', { info: res.result })
  //     if (to.path === '/login') { //  跳转到
  //       next({ path: '/' })
  //     }
  //     next()
  //   }
  // })
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js